import { render } from "./EnquiryPage.vue?vue&type=template&id=f235acfa"
import script from "./EnquiryPage.vue?vue&type=script&lang=js"
export * from "./EnquiryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__